import { render } from "./EtikaProfesionale.vue?vue&type=template&id=7b8b398e&scoped=true"
import script from "./EtikaProfesionale.vue?vue&type=script&lang=js"
export * from "./EtikaProfesionale.vue?vue&type=script&lang=js"

import "./EtikaProfesionale.vue?vue&type=style&index=0&id=7b8b398e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8b398e"]])

export default __exports__